// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3HEsh","content":"Consent_content__3BO-X","footer":"Consent_footer__3QMq-"};